import React, { PropTypes, Component } from 'react'
import R from 'ramda'
import styled from 'styled-components'
import SearchBar from '../../components/SearchBar'
import Loader from '../../components/Loader'
import { searchQueryDefault } from '../../Utils/Defaults'
import { exportPropertiesToCsv } from '../../sources/AdminSource'
import SuccessModal from '../../components/Modal/SuccessModal'
import ErrorModal from '../../components/Modal/ErrorModal'
import { translate } from 'react-i18next'

const Container = styled.section``

class Search extends Component {
  constructor (props) {
    super(props)
    this.state = {
      settings: R.clone(searchQueryDefault),
      modal: false,
      generating: false
    }
    this.updateSettings = this.updateSettings.bind(this)
    this.propertyDetails = this.propertyDetails.bind(this)
    this.exportProperties = this.exportProperties.bind(this)
    this.closeModal = this.closeModal.bind(this)
  }

  updateSettings (settings) {
    this.setState({ settings })
  }

  propertyDetails (id) {
    this.props.router.push('/property/' + id)
  }

  exportProperties () {
    this.setState({ generating: true }, () => {
      exportPropertiesToCsv(this.state.settings)
        .then(response => {
          this.setState({ modal: 'success', generating: false })
        })
        .catch(error => {
          this.setState({ modal: 'error', generating: false })
          console.log(error)
        })
    })
  }

  closeModal () {
    this.setState({ modal: false })
  }

  render () {
    const { children, router, user, t } = this.props
    const isRegionSearch =
      router.location.pathname.indexOf('/search/find') >= 0 ||
      router.location.pathname.indexOf('/search/region') >= 0
    let searchSettings = R.clone(this.state.settings)
    let querySettings = R.clone(this.state.settings)

    return (
      <Container isRegionSearch={isRegionSearch}>
        {!isRegionSearch && (
          <SearchBar
            exportAction={this.exportProperties}
            settings={searchSettings}
            updateSettings={this.updateSettings}
            searchRequests={user.preferences}
          />
        )}
        <Loader visible={this.state.generating} />
        <SuccessModal
          visible={this.state.modal === 'success'}
          closeAction={this.closeModal}
          header={t('Email Sent')}
          message={t('An email was sent with the Excel')}
        />
        <ErrorModal
          visible={this.state.modal === 'error'}
          closeAction={this.closeModal}
          header={t('Error')}
          message={t('There was an error when creating the Excel file')}
        />
        {children &&
          React.cloneElement(children, {
            settings: querySettings,
            updateSettings: this.updateSettings,
            propertyDetails: this.propertyDetails,
            user
          })}
      </Container>
    )
  }
}

Search.propTypes = {
  user: PropTypes.object,
  children: PropTypes.node,
  router: PropTypes.object,
  t: PropTypes.func
}
export default translate([ 'common', 'forms', 'search' ], { wait: true })(
  Search
)



// WEBPACK FOOTER //
// ./src/pages/Search/index.js